import React from 'react';
import { InputGroup as InputGroupHoi, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';

const useStyles = createUseStyles(styles, 'InputGroup');

function InputGroup({ labelForExpand = [], inputs, ...props }) {
    const { t } = useWeb5Context();
    const classes = useStyles();
    const showInputsLabel = labelForExpand[0] ? t(labelForExpand[0]) : labelForExpand[0];
    const hideInputsLabel = labelForExpand[1] ? t(labelForExpand[1]) : labelForExpand[1];

    if (!inputs || inputs.length === 0) return null;

    return (
        <InputGroupHoi
            {...props}
            className={classes.root}
            inputs={inputs}
            showInputsLabel={showInputsLabel}
            hideInputsLabel={hideInputsLabel}
            isFullWidth
        />
    );
}

export default InputGroup;
